// extracted by mini-css-extract-plugin
export default {"content":"LecturesPage_content__pgn7z"};